export enum PaymentMethodEnum {
  Cash = 'Cash',
  COD = 'COD',
  QuickPay = 'QuickPay',
  Days5 = '5 days',
  Days7 = '7 days',
  Days10 = '10 days',
  Days15 = '15 days',
  Days20 = '20 days',
  Days30 = '30 days',
  Days45 = '45 days',
  Other = 'Other',
  COP = 'COP',
  CKOD = 'CKOD',
  ACH = 'ACH',
  FACTORING = 'FACTORING',
  CheckAtDelivery = 'Check at Delivery',
  USHIP = 'USHIP',
}
